import { useTranslation } from 'react-i18next';
import { Users } from 'lucide-react';
import { Badge } from '@ntconsult/aluma-react';

export function SharedBadge() {
  const { t } = useTranslation('common');
  return (
    <Badge
      variant="soft"
      tone="brand"
      size="sm"
      icon={<Users className="w-3 h-3" aria-hidden="true" />}
    >
      {t('shared')}
    </Badge>
  );
}
